import { Component, OnInit, Inject } from '@angular/core';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from '../../constant/common.constant';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebSocketService } from 'src/app/services/websocket.service';
import { FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { environment } from 'src/environments/environment';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';

@Component({
  selector: 'app-image-pop-up',
  templateUrl: './image-pop-up.component.html',
  styleUrls: ['./image-pop-up.component.scss'],
  standalone: false // NOSONAR
})
export class ImagePopUpComponent implements OnInit {
  heading: any = 'Image Resolution';
  safetyEventId: any;
  safetyFinalEventId: any;
  jsonObject: any;
  backendResponse: any;
  image1: SafeResourceUrl;
  image2: SafeResourceUrl;
  image3: SafeResourceUrl;
  image4: SafeResourceUrl;
  templateFile: any;
  timageId1: any;
  timageId2: any;
  timageId3: any;
  timageId4: any;
  img1: boolean = false;
  img2: boolean = false;
  img3: boolean = false;
  img4: boolean = false;
  file1: any;
  file2: any;
  file3: any;
  file4: any;
  errorMessage: any;
  successMessage: any;
  upload1: boolean = false;
  upload2: boolean = false;
  upload3: boolean = false; const_content = 'data:image/png;base64,'
  upload4: boolean = false; const_upld_err = 'File Format is not accepted. The accepted formats are .png, .jpg, .jpeg, .jpe, .jif, .jfif, .jfi, .jp2, .j2k, .jpf, .jpm, .jpg2, .j2c, .jpc, .jpx, .mj2, .gif, .tiff, .tif'
  selectedFileName: any; const_errmsg = 'Error while uploading'
  selectedFilePath: any; const_uppload = "Uploading failed !!!"
  constructor(
     private readonly aetSafetyDashboardService : AetSafetyDashboardService,
    public dialogRef: MatDialogRef<ImagePopUpComponent>,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    public sanitizer: DomSanitizer,
    private readonly webSocketService: WebSocketService
  ) { }

  ngOnInit(): void {
    this.safetyEventId = this.dataStore.data.safetyEventId;
    this.safetyFinalEventId = this.dataStore.data.safetyEventFinalId;
    // if(this.file1 !=   undefined)
    this.refreshData();

  }

  private extractImageRecords(response: any): any[] {
    const payload = response?.event ?? response?.data ?? response?.payload ?? response;
    if (Array.isArray(payload)) {
      return payload;
    }
    if (Array.isArray(payload?.event)) {
      return payload.event;
    }
    if (Array.isArray(payload?.images)) {
      return payload.images;
    }
    if (Array.isArray(payload?.safetyImages)) {
      return payload.safetyImages;
    }
    return [];
  }

  private resolveImageContent(item: any): string | null {
    const value =
      item?.imageInString ??
      item?.imageString ??
      item?.imageBase64 ??
      item?.fileBase64 ??
      item?.image ??
      item?.imgInString ??
      item?.image1;

    if (typeof value != 'string') { // NOSONAR
      return null;
    }

    const trimmed = value.trim();
    if (!trimmed.length) {
      return null;
    }

    if (trimmed.startsWith('data:image')) {
      return trimmed;
    }

    const withoutQuotes = trimmed
      .replace(/^['"]+/, '')
      .replace(/['"]+$/, '');
    const compactBase64 = withoutQuotes.replace(/\s+/g, '');
    const decodedMaybe = this.decodeIfDoubleEncoded(compactBase64);
    if (decodedMaybe) {
      return decodedMaybe;
    }
    return compactBase64.length ? compactBase64 : null;
  }

  private decodeIfDoubleEncoded(value: string): string | null {
    if (!value || value.startsWith('data:image')) {
      return null;
    }

    if (this.looksLikeImageBase64(value)) {
      return value;
    }

    try {
      const decoded = atob(value).trim().replace(/\s+/g, '');
      return this.looksLikeImageBase64(decoded) ? decoded : null;
    } catch {
      return null;
    }
  }

  private looksLikeImageBase64(value: string): boolean {
    return value.startsWith('/9j/') ||
      value.startsWith('iVBORw0KGgo') ||
      value.startsWith('R0lGOD') ||
      value.startsWith('SUkq') ||
      value.startsWith('TU0A');
  }

  private resolveImageId(item: any): any {
    return item?.timageId ?? item?.tImageId ?? item?.imageId ?? item?.id ?? null;
  }

  private toSafeImageUrl(value: string): SafeResourceUrl {
    if (value.startsWith('data:image')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }

    const mimeType = this.detectImageMimeType(value);
    const normalized = `data:${mimeType};base64,${value}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(normalized);
  }

  private detectImageMimeType(base64: string): string {
    if (base64.startsWith('/9j/')) {
      return 'image/jpeg';
    }
    if (base64.startsWith('iVBORw0KGgo')) {
      return 'image/png';
    }
    if (base64.startsWith('R0lGOD')) {
      return 'image/gif';
    }
    if (base64.startsWith('SUkq') || base64.startsWith('TU0A')) {
      return 'image/tiff';
    }
    return 'image/jpeg';
  }

  private resetImageSlots(): void {
    this.image1 = null;
    this.image2 = null;
    this.image3 = null;
    this.image4 = null;

    this.img1 = true;
    this.img2 = true;
    this.img3 = true;
    this.img4 = true;

    this.upload1 = false;
    this.upload2 = false;
    this.upload3 = false;
    this.upload4 = false;

    this.timageId1 = null;
    this.timageId2 = null;
    this.timageId3 = null;
    this.timageId4 = null;
  }

  refreshData() {
    this.aetSafetyDashboardService
      .imageResolutionCall(this.safetyEventId, this.safetyFinalEventId)
      ?.subscribe((response: any) => {
        const imageRecords = this.extractImageRecords(response);
        this.backendResponse = imageRecords;

        const sortedRecords = [...imageRecords].sort((a, b) => {
          const aId = Number(a?.id ?? a?.timageId ?? a?.tImageId ?? 0);
          const bId = Number(b?.id ?? b?.timageId ?? b?.tImageId ?? 0);
          return bId - aId;
        });

        this.jsonObject = sortedRecords.length < 4
          ? sortedRecords.concat(Array(4 - sortedRecords.length).fill(null))
          : sortedRecords.slice(0, 4);

        this.resetImageSlots();

        const imageString1 = this.resolveImageContent(this.jsonObject[0]);
        const imageString2 = this.resolveImageContent(this.jsonObject[1]);
        const imageString3 = this.resolveImageContent(this.jsonObject[2]);
        const imageString4 = this.resolveImageContent(this.jsonObject[3]);

        if (imageString1) {
          this.image1 = this.toSafeImageUrl(imageString1);
          this.img1 = false;
          this.upload1 = true;
        }

        if (imageString2) {
          this.image2 = this.toSafeImageUrl(imageString2);
          this.img2 = false;
          this.upload2 = true;
        }

        if (imageString3) {
          this.image3 = this.toSafeImageUrl(imageString3);
          this.img3 = false;
          this.upload3 = true;
        }

        if (imageString4) {
          this.image4 = this.toSafeImageUrl(imageString4);
          this.img4 = false;
          this.upload4 = true;
        }

        this.timageId1 = this.resolveImageId(this.jsonObject[0]);
        this.timageId2 = this.resolveImageId(this.jsonObject[1]);
        this.timageId3 = this.resolveImageId(this.jsonObject[2]);
        this.timageId4 = this.resolveImageId(this.jsonObject[3]);
      }, (_error) => {
        this.resetImageSlots();
      });
  }

  onClick(event) {

    event.target.value = '';
  }

  fileChange(_event) {
// do nothing
  }

  handleUpload1(event: any, cardName: any) {
    this.errorMessage = null;
    const file = event?.target?.files?.[0];
    if (!file || !file?.name) {
      this.errorMessage = this.const_upld_err;
      return;
    }
    this.file1 = file;
    const fileName = this.file1.name;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    if (extension.toLowerCase() !=   '.jpg' && extension.toLowerCase() !=   '.jpeg' && extension.toLowerCase() !=   '.jpe' && extension.toLowerCase() !=   '.jif'                          // NOSONAR
      && extension.toLowerCase() !=   '.jfif' && extension.toLowerCase() !=   '.jfi' && extension.toLowerCase() !=   '.jp2' && extension.toLowerCase() !=   '.j2k'                         // NOSONAR
      && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpm' && extension.toLowerCase() !=   '.jpg2'                         // NOSONAR
      && extension.toLowerCase() !=   '.j2c' && extension.toLowerCase() !=   '.jpc' && extension.toLowerCase() !=   '.jpx' && extension.toLowerCase() !=   '.mj2'                         // NOSONAR
      && extension.toLowerCase() !=   '.png' && extension.toLowerCase() !=   '.gif' && extension.toLowerCase() !=   '.tiff' && extension.toLowerCase() !=   '.tif') {                         // NOSONAR
      this.errorMessage = this.const_upld_err;
    }
    else {
      const reader = new FileReader();
      reader.readAsDataURL(file);


      reader.onload = () => {
        if (cardName && typeof reader.result === 'string') {
          this.image1 = reader.result;
          this.img1 = false;

        }
      };
      reader.onerror = () => {
        // alert(this.const_errmsg) 
        this.errorMessage = this.const_errmsg;
      }
    }
  }
  handleUpload2(event: any, cardName: any) {
    this.errorMessage = null;
    const file = event?.target?.files?.[0];
    if (!file || !file?.name) {
      this.errorMessage = this.const_upld_err;
      return;
    }
    this.file2 = file;
    const fileName = this.file2.name;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    if (extension.toLowerCase() !=   '.jpg' && extension.toLowerCase() !=   '.jpeg' && extension.toLowerCase() !=   '.jpe' && extension.toLowerCase() !=   '.jif'                         // NOSONAR
      && extension.toLowerCase() !=   '.jfif' && extension.toLowerCase() !=   '.jfi' && extension.toLowerCase() !=   '.jp2' && extension.toLowerCase() !=   '.j2k'                         // NOSONAR
      && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpm' && extension.toLowerCase() !=   '.jpg2'                         // NOSONAR
      && extension.toLowerCase() !=   '.j2c' && extension.toLowerCase() !=   '.jpc' && extension.toLowerCase() !=   '.jpx' && extension.toLowerCase() !=   '.mj2'                         // NOSONAR
      && extension.toLowerCase() !=   '.png' && extension.toLowerCase() !=   '.gif' && extension.toLowerCase() !=   '.tiff' && extension.toLowerCase() !=   '.tif') {                         // NOSONAR
      this.errorMessage = this.const_upld_err;
    }
    else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (cardName && typeof reader.result === 'string') {
          this.image2 = reader.result;
          this.img2 = false;

        }
      };
      reader.onerror = () => {
        // alert(this.const_errmsg) 
        this.errorMessage = this.const_errmsg;
      }
    }
  }
  handleUpload3(event: any, cardName: any) {
    this.errorMessage = null;
    const file = event?.target?.files?.[0];
    if (!file || !file?.name) {
      this.errorMessage = this.const_upld_err;
      return;
    }
    this.file3 = file;
    const fileName = this.file3.name;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    if (extension.toLowerCase() !=   '.jpg' && extension.toLowerCase() !=   '.jpeg' && extension.toLowerCase() !=   '.jpe' && extension.toLowerCase() !=   '.jif'                         // NOSONAR
      && extension.toLowerCase() !=   '.jfif' && extension.toLowerCase() !=   '.jfi' && extension.toLowerCase() !=   '.jp2' && extension.toLowerCase() !=   '.j2k'                         // NOSONAR
      && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpm' && extension.toLowerCase() !=   '.jpg2'                         // NOSONAR
      && extension.toLowerCase() !=   '.j2c' && extension.toLowerCase() !=   '.jpc' && extension.toLowerCase() !=   '.jpx' && extension.toLowerCase() !=   '.mj2'                         // NOSONAR
      && extension.toLowerCase() !=   '.png' && extension.toLowerCase() !=   '.gif' && extension.toLowerCase() !=   '.tiff' && extension.toLowerCase() !=   '.tif') {                         // NOSONAR
      this.errorMessage = this.const_upld_err;
    }
    else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (cardName && typeof reader.result === 'string') {
          this.image3 = reader.result;
          this.img3 = false;

        }
      };
      reader.onerror = () => {
        // alert(this.const_errmsg)
        this.errorMessage = this.const_errmsg;
      }
    }
  }
  handleUpload4(event: any, cardName: any) {
    this.errorMessage = null;
    const file = event?.target?.files?.[0];
    if (!file || !file?.name) {
      this.errorMessage = this.const_upld_err;
      return;
    }
    this.file4 = file;
    const fileName = this.file4.name;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    if (extension.toLowerCase() !=   '.jpg' && extension.toLowerCase() !=   '.jpeg' && extension.toLowerCase() !=   '.jpe' && extension.toLowerCase() !=   '.jif'                         // NOSONAR
      && extension.toLowerCase() !=   '.jfif' && extension.toLowerCase() !=   '.jfi' && extension.toLowerCase() !=   '.jp2' && extension.toLowerCase() !=   '.j2k'                         // NOSONAR
      && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpf' && extension.toLowerCase() !=   '.jpm' && extension.toLowerCase() !=   '.jpg2'                         // NOSONAR
      && extension.toLowerCase() !=   '.j2c' && extension.toLowerCase() !=   '.jpc' && extension.toLowerCase() !=   '.jpx' && extension.toLowerCase() !=   '.mj2'                         // NOSONAR
      && extension.toLowerCase() !=   '.png' && extension.toLowerCase() !=   '.gif' && extension.toLowerCase() !=   '.tiff' && extension.toLowerCase() !=   '.tif') {                         // NOSONAR
      this.errorMessage = this.const_upld_err;
    }
    else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (cardName && typeof reader.result === 'string') {
          this.image4 = reader.result;
          this.img4 = false;

        }
      };
      reader.onerror = () => {
        // alert(this.const_errmsg) 
        this.errorMessage = this.const_errmsg;
      }
    }
  }

  loadImages() { 
    console.info('some')
  }

  close() {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  onNoClick() {
    this.dialogRef.close({ event: 'CloseEvent' });
    this.img1 = false;
    this.img2 = false;
    this.img3 = false;
    this.img4 = false;
  }

  saveClick(file: any, _fileNum: any) {

    if (file !=   undefined) {  // NOSONAR
      this.ngxUiLoaderService.start(CommonConstant.loader);
      this.successMessage = null;
      this.errorMessage = null;
      this.aetSafetyDashboardService
        .imagePopUp(this.safetyEventId, this.safetyFinalEventId, file)
        .subscribe(
          (response) => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);

            if (response == 'Success') {   // NOSONAR
              this.successMessage = "Uploaded successfully !!!";
              setTimeout(() => {
                this.errorMessage = null;
                this.successMessage = null;
              }, 5000);
              this.refreshData();
            } else {
              this.errorMessage = this.const_uppload;
              setTimeout(() => {
                this.errorMessage = null;
                this.successMessage = null;
              }, 5000);
            }
          },
          (_error) => {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.errorMessage = "Error";
          }
        );
    }
    else {
      this.errorMessage = "Please Upload a file..";
      setTimeout(() => {
        this.errorMessage = null;
        this.successMessage = null;
      }, 5000);
    }
  }

  async newsaveClick(file: any, _fileNum: any) {

    if (file !=   undefined) {  // NOSONAR
      this.ngxUiLoaderService.start(CommonConstant.loader);
      this.successMessage = null;
      this.errorMessage = null;
      const parsedFileName = file?.name
        ?.replace(/\s+/g, '_') // Replace spaces with underscore
        ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
      this.selectedFilePath = `AET/SafetyEventImage/${this.selectedFileName}`;
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePath }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': file?.type, // Set file content type
          'x-auth-token': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: file,
        });

        if (!response.ok) {
          this.errorMessage = 'Failed to upload file!'
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') {   // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.ngxUiLoaderService.stop(CommonConstant.loader);
                this.webSocketService.closeConnection();
                this.errorMessage = 'Failed to upload file. Please re-upload the file.'
              } else {
                console.info('WebSocket error:', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages: any) => {
            console.info(messages, "messages from Lambda");

            const backendResp = messages.backendResponse;
            try {
              if (backendResp) {
                // Check backend API response for success/failure
                
                this.ngxUiLoaderService.stop(CommonConstant.loader);
                const response = backendResp;
                if (response == 'Success') {   // NOSONAR
                  this.successMessage = "Uploaded successfully !!!";
                  setTimeout(() => {
                    this.errorMessage = null;
                    this.successMessage = null;
                  }, 5000);
                  this.refreshData();
                } else {
                  this.errorMessage = this.const_uppload;
                  setTimeout(() => {
                    this.errorMessage = null;
                    this.successMessage = null;
                  }, 5000);
                }

              }
            }
            catch {
              this.errorMessage = this.const_uppload;
                  setTimeout(() => {
                    this.errorMessage = null;
                    this.successMessage = null;
                  }, 5000);
            }
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.webSocketService.closeConnection();
          })
      } catch (err) {
        console.info('Unexpected upload exception:', err);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.webSocketService.closeConnection();
        this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
      }
    }
    else {
      this.errorMessage = "Please Upload a file..";
      setTimeout(() => {
        this.errorMessage = null;
        this.successMessage = null;
      }, 5000);
    }
  }

  handleDelete(_value: any) {
    // do nothing
  }

  deleteImage(value: any, _fileNum: any) {
    if (value) {
      this.aetSafetyDashboardService
        .deleteimageAsAsked(this.safetyEventId, this.safetyFinalEventId, value)
        .subscribe(
          (_response) => {

            this.refreshData();
          },
          (_error) => {
          // do nothing
          }
        );
    }
    else {
      this.errorMessage = "No File is there to be deleted..";
      setTimeout(() => {
        this.errorMessage = null;
        this.successMessage = null;
      }, 5000);
    }
  }

  handleDelete1(value: any) {
    this.image1 = null;
    this.img1 = true;
    this.file1 = null;

    this.deleteImage(value, 'file1');
  }
  handleDelete2(value: any) {
    this.image2 = null;
    this.img2 = true;
    this.file2 = null;
    this.deleteImage(value, 'file2');
  }
  handleDelete3(value: any) {
    this.image3 = null;
    this.img3 = true;
    this.file3 = null;
    this.deleteImage(value, 'file3');
  }
  handleDelete4(value: any) {
    this.image4 = null;
    this.img4 = true;
    this.file4 = null;
    this.deleteImage(value, 'file4');
  }
  closeMessage() {
    this.successMessage = null;
    this.errorMessage = null;
  }
}
